<template>
    <vx-expandable-card>
        <template v-slot:header> Description </template>

        <template v-slot:content>
            <vx-input v-model="model" size="lg" :rows="4" :error="props.error" />
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxExpandableCard, VxInput } from '@voxie/frontend-components';

const model = defineModel();

const props = defineProps({
    error: String,
});
</script>
